import React from 'react';
import StatCard from "../../../common/StatCard";

const OverviewTab = ({shortCode,reputationLinks,patientComments,patientFeedbacks,formatDate,getFeedbackIcon,getStatusBadge}) => {




    return (
        <div className="row g-4">
            {/* Short Code Card */}
            <div className="col-lg-6">
                <div className="card border-0 shadow-sm h-100">
                    <div className="card-header bg-transparent border-0">
                        <h5 className="card-title mb-0">
                            <i className="bi bi-code-slash text-primary me-2"></i>
                            Short Code
                        </h5>
                    </div>
                    <div className="card-body">
                        {shortCode ? (
                            <div className="text-center py-4">
                                <div className="display-4 fw-bold text-primary mb-2">
                                    {shortCode.shortCode}
                                </div>
                                <p className="text-muted mb-3">Your clinic's unique identifier</p>
                                <p className="text-muted mb-3">
                                    This code is used in your reputation URLs. e.g. https://eyeconx.com/{shortCode.shortCode}
                                </p>
                                <button className="btn btn-outline-primary btn-sm" onClick={() => navigator.clipboard.writeText(`https://eyeconx.com/${shortCode.shortCode}`)}>
                                    <i className="bi bi-copy me-1"></i>
                                    Copy Url
                                </button>

                            </div>
                        ) : (
                            <div className="text-center py-4">
                                <i className="bi bi-exclamation-triangle display-4 text-muted mb-3"></i>
                                <p className="text-muted">No short code configured</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Quick Stats */}
            <div className="col-lg-6">
                <div className="card border-0 shadow-sm h-100">
                    <div className="card-header bg-transparent border-0">
                        <h5 className="card-title mb-0">
                            <i className="bi bi-graph-up text-success me-2"></i>
                            Quick Stats
                        </h5>
                    </div>
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-6">
                            <StatCard
                                title="Active Links"
                                value={reputationLinks?.length}
                                change=""
                                icon="bi bi-link-45deg"
                                color="primary"

                            />
                            </div>
                            <div className="col-6">
                            <StatCard
                                title="Total Comments"
                                value={patientComments.totalElements}
                                change=""
                                icon="bi bi-chat-dots"
                                color="info"

                            />
                            </div>
                            <div className="col-6">
                            <StatCard
                                title="Patient Feedback"
                                value={patientFeedbacks.totalElements}
                                change=""
                                icon="bi bi-emoji-smile"
                                color="warning"

                            />
                            </div>
                            <div className="col-6">
                            <StatCard
                                title="Short Code"
                                value=  {shortCode.shortCode}
                                change=""
                                icon="bi bi-braces"
                                color="success"

                            />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Recent Activity */}
            <div className="col-12">
                <div className="card border-0 shadow-sm">
                    <div className="card-header bg-transparent border-0">
                        <h5 className="card-title mb-0">
                            <i className="bi bi-activity text-info me-2"></i>
                            Recent Activity
                        </h5>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6">
                                <h6 className="text-muted mb-3">Latest Comments</h6>
                                {patientComments.content.slice(0, 3).map((comment) => (
                                    <div key={comment.id} className="d-flex align-items-start mb-3">
                                        <div className="avatar bg-primary text-white rounded-circle p-2 me-3">
                                            {comment.firstName.charAt(0)}{comment.lastName.charAt(0)}
                                        </div>
                                        <div className="flex-grow-1">
                                            <div className="d-flex justify-content-between align-items-start">
                                                <h6 className="mb-1">{comment.firstName} {comment.lastName}</h6>
                                                {getStatusBadge(comment.status)}
                                            </div>
                                            <p className="text-muted small mb-1">{comment.notes}</p>
                                            <small className="text-muted">{formatDate(comment.createdAt)}</small>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="col-md-6">
                                <h6 className="text-muted mb-3">Recent Feedback</h6>
                                {patientFeedbacks.content.slice(0, 3).map((feedback) => (
                                    <div key={feedback.id} className="d-flex justify-content-between align-items-center mb-3 p-3 bg-light rounded">
                                        <div>
                                            <h6 className="mb-1">{feedback.patientName}</h6>
                                            <small className="text-muted">{formatDate(feedback.createdAt)}</small>
                                        </div>
                                        {getFeedbackIcon(feedback.feedback)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OverviewTab;